export default __webpack_public_path__ + "static/media/lij-logo.b636c032.png";